module.exports = __webpack_public_path__ + "static/media/Sertec-logo.b9433c51.png";